(() => {
  if (window.aldenoMegaMenuReady) return;
  window.aldenoMegaMenuReady = true;
  let opener;
  const menu = () => document.getElementById('aldeno-mega-menu');
  const reset = () => {
    document.documentElement.classList.remove('aldeno-menu-open');
    document.body.classList.remove('aldeno-menu-open');
    document.querySelectorAll('[data-aldeno-menu-open]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-aldeno-menu-open]');
    const dialog = menu();
    if (!dialog) return;
    if (trigger) {
      event.preventDefault();
      opener = trigger;
      dialog.showModal();
      document.documentElement.classList.add('aldeno-menu-open');
      document.body.classList.add('aldeno-menu-open');
      document.querySelectorAll('[data-aldeno-menu-open]').forEach(el => el.setAttribute('aria-expanded', 'true'));
    } else if (event.target.closest('[data-aldeno-menu-close]')) {
      dialog.close();
    } else if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  // Native dialog supplies modal focus containment, background inertness and Escape.
  document.addEventListener('close', event => {
    if (event.target.id === 'aldeno-mega-menu') reset();
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('#aldeno-mega-menu')) reset();
  });
  window.addEventListener('pagehide', () => { if (menu()?.open) menu().close(); });
})();
